<template>
<div style="position:relative;">
<div class="col-md-12 flecha-container">  
  <h1 data-aos="fade-up"  data-aos-duration="1500">NOSOTROS</h1>
    <img data-aos="fade-right"  data-aos-duration="1500" class="flecha" src="~imgs/icons/Flecha_Negra.png">
  </div>  <div id="nosotros" class="container">
    <div id="content" class="row">

      <div id="left" class="col-sm-4 text-right pull-left">
        <div data-aos="fade-right"  data-aos-duration="2500" class="row">
          <div class="col-sm-3 icon minor-res-disp">
            <img src="~imgs/icons/Nostros_Foco.png" alt="">
          </div>
          <div class="col-sm-9 ">
            <p>A&A Logistics Group fue fundada originalmente con el nombre de A&A FORWARDERS en Octubre del 2007.</p>
          </div>
          <div class="col-sm-3 icon major-res-disp">
            <img src="~imgs/icons/Nostros_Foco.png" alt="">
          </div>
        </div>
        <div data-aos="fade-right"  data-aos-duration="2500" class="row">
        <div class="col-sm-3 icon minor-res-disp">
            <img src="~imgs/icons/Nosotros_Lapiz.png" alt="">
          </div>
          <div class="col-sm-9">
            <p>Fue en el 2009 cuando cambiamos nuestro nombre A&A Logistics Group.</p>
          </div>
          <div class="col-sm-3 icon major-res-disp">
            <img src="~imgs/icons/Nosotros_Lapiz.png" alt="">
          </div>
        </div>
      </div>

      <div data-aos="fade-up"
     data-aos-anchor-placement="bottom-bottom"   data-aos-duration="1000" id="image-col" class="col-sm-4">
        <img src="~imgs/nosotros_truck.png" alt="">
      </div>

      <div data-aos="fade-left"  data-aos-duration="2500" id="right" class="col-sm-4 text-left pull-right">
        <div class="row">
          <div class="col-sm-3 icon">
            <img src="~imgs/icons/Nosotros_Certificado.png" alt="">
          </div>
          <div class="col-sm-9">
            <p>Nuestra certificación C-TPAT nos ha permitido ganar la confianza de nuestros clientes.</p>
          </div>
        </div>
        <div data-aos="fade-left"  data-aos-duration="2500" class="row">
          <div class="col-sm-3 icon">
            <img src="~imgs/icons/Nosotros_Mano.png" alt="">
          </div>
          <div class="col-sm-9">
            <p>A través de los años hemos logrado ser una empresa con un alto nivel de profesionalismo.</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
// TODO: falta hacer resolucion celphone
import Arrow from './reusable/ArrowRight.vue'
export default {
  components:{
    Arrow
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.container-fluid{
  margin: 0;
  padding: 0;
}
#nosotros{
  padding: 25px 0 50px;
  height: 100%;
   
  .row{
    padding-top: 50px;
    @include tablet{
            text-align:center;
           }
    #left{
      @include tablet{
        width:100%;
        margin:auto;
      }
      .icon{
        img{
          width: 100%;
           @include tablet{
            width:50%;
           }
        }
      }
    }
    #image-col{
      img{
        width: 100%;
         @include tablet{
            display:none;
           }
      }
    }
    #right{
      padding-top: 70px;
      @include tablet{
        padding-top: 0px;
        width:100%;
        margin:auto;
      }
      .icon{
        img{
          width: 100%;
           @include tablet{
            width:50%;
            margin:auto;
           }
        }
      }
      
    }
  }
}
.flecha-container{
  width:100%;
  text-align:left;
}
.flecha-container h1{
float:right;
margin-right:20px;
margin-top:20px;

font-size:30pt;
}
.flecha{
margin-left:-30px;
margin-top:20px;
width:80%;
}

.minor-res-disp{
   display:none;
}
.major-res-disp{
   display:inline-block;
}

@media screen and (max-width: 920px){
  .minor-res-disp{
   display:inline-block;
  }
  .major-res-disp{
   display:none;
  } 
}
</style>



// WEBPACK FOOTER //
// Nosotros.vue?015ea934